export const textareaData = {
  "controlName": "题干",
  "controlType": "Textarea",
  "controlDefValue": "请输入题干内容",
  "controlValue": "",
  "isRequired": true
}
export const UIdata = {
  "controlName": "",
  "controlType": "UploadImg",
  "controlDefValue": "请输入",
  "controlValue": [],
  "isRequired": false
}
export const IUIdata = {
  "controlName": "可选项描述",
  "controlType": "InputUploadImg",
  "controlDefValue": "请输入",
  "controlValue": [],
  "isRequired": true,
  "checked": "single",
}
export const IUIcontrols =  [
  {"tab": "A", "content": "", "img": ""},
  {"tab": "B", "content": "", "img": ""},
  {"tab": "C", "content": "", "img": ""},
  {"tab": "D","content": "", "img": ""},
  {"tab": "E", "content": "", "img": ""}
]
export const JUDGEcontrols =  [
  {"tab": "正确", "content": 0},
  {"tab": "错误", "content": 1}
]

export const GAPcontrols =  [
  {"tab": "第一空答案", "content": ""},
  {"tab": "第二空答案", "content": ""},
  {"tab": "第三空答案", "content": ""}
]
export const jxtextareaData = {
  "controlName": "解析",
  "controlType": "Textarea",
  "controlDefValue": "请输入解析内容",
  "controlValue": "",
  "isRequired": false
}
export const jxUIdata = {
  "controlName": "",
  "controlType": "UploadImg",
  "controlDefValue": "请输入",
  "controlValue": [],
  "isRequired": false
}


// WEBPACK FOOTER //
// ./src/views/resource/json/index.js